module.exports = __webpack_public_path__ + "static/media/EventsImage.e0ffe039.png";